module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "panels"
  }, [_c('DocumentUploader', {
    ref: "igazolasfeltolto"
  }), _vm._v(" "), _c('PointPanel', {
    ref: "pontszam"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Rendszeres szociális támogatás és költségtérítés mérséklés")]), _vm._v(" "), _c('HallgatoAdatok', {
    on: {
      "onReady": function (hallgato, hallgato_szakok, szocpontParameterek) {
        this$1.save_enabled = true;
        this$1.hallgato = hallgato;
        this$1.hallgato_szakok = hallgato_szakok;
        this$1.szocpontParameterek = szocpontParameterek;
        this$1.tavolsagpontKalk();
        this$1.kalkJovedelemTipusok();
        this$1.kalkJovedelemOsszeg();
        this$1.jovedelmekPontKalkulacio();
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "tooltipDescription": _vm.getTooltipDescriptionByKey('Anya_fogl'),
      "errors": _vm.errors,
      "iconclass": "fa fa-pencil",
      "id": "Anya_Fogl",
      "label": "Édesanyja foglalkozása, munkahelye",
      "name": "Anya_Fogl"
    },
    model: {
      value: (_vm.form.Anya_Fogl),
      callback: function($$v) {
        _vm.form.Anya_Fogl = $$v
      },
      expression: "form.Anya_Fogl"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "tooltipDescription": _vm.getTooltipDescriptionByKey('Apa_fogl'),
      "errors": _vm.errors,
      "iconclass": "fa fa-pencil",
      "id": "Apa_Fogl",
      "label": "Édesapja foglalkozása, munkahelye",
      "name": "Apa_Fogl"
    },
    model: {
      value: (_vm.form.Apa_Fogl),
      callback: function($$v) {
        _vm.form.Apa_Fogl = $$v
      },
      expression: "form.Apa_Fogl"
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Igényelt támogatások")]), _vm._v(" "), _vm._l((_vm.tamogatasok), function(option, i) {
    return _c('div', {
      staticClass: "form-checkbox-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.tamogatasok),
        expression: "form.tamogatasok"
      }],
      attrs: {
        "id": 'tamogatas_' + i,
        "name": 'tamogatas_' + i,
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.form.tamogatasok) ? _vm._i(_vm.form.tamogatasok, option.value) > -1 : (_vm.form.tamogatasok)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.form.tamogatasok,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.form.tamogatasok = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.tamogatasok = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.form.tamogatasok = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'tamogatas_' + i
      }
    }, [_c('div', {
      staticClass: "icon"
    }), _vm._v("\n              " + _vm._s(option.text) + "\n              "), _c('Tooltip', {
      attrs: {
        "description": _vm.getTooltipDescriptionByKey(option.value)
      }
    })], 1)])
  }), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return [(error.id == 'tamogatasok') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.tamogatasok.indexOf('Kolts_Csokk') > -1),
      expression: "form.tamogatasok.indexOf('Kolts_Csokk') > -1"
    }]
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.TMDK),
      expression: "form.TMDK"
    }],
    attrs: {
      "id": "TMDK",
      "name": "TMDK",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.TMDK) ? _vm._i(_vm.form.TMDK, "1") > -1 : (_vm.form.TMDK)
    },
    on: {
      "click": function($event) {
        _vm.fileBoxChange('TMDK', 'TMDK tevékenység', '', $event, 'TMDK')
      },
      "__c": function($event) {
        var $$a = _vm.form.TMDK,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.TMDK = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.TMDK = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.TMDK = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "TMDK"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                TMDK tevékenység az elmúlt egy évben\n                "), _c('Tooltip', {
    attrs: {
      "description": _vm.getTooltipDescriptionByKey('TMDK')
    }
  })], 1)])]), _vm._v(" "), _c('textareabox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.TMDK),
      expression: "form.TMDK"
    }],
    attrs: {
      "errors": _vm.errors,
      "cstyle": "min-height: 100px",
      "iconclass": "fa fa-pencil",
      "autogrow": true,
      "maxlength": "1000",
      "id": "TMDKSzoveg",
      "label": "",
      "name": "TMDKSzoveg"
    },
    model: {
      value: (_vm.form.TMDKSzoveg),
      callback: function($$v) {
        _vm.form.TMDKSzoveg = $$v
      },
      expression: "form.TMDKSzoveg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.HallgSzervTev),
      expression: "form.HallgSzervTev"
    }],
    attrs: {
      "id": "HallgSzervTev",
      "name": "HallgSzervTev",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.HallgSzervTev) ? _vm._i(_vm.form.HallgSzervTev, "1") > -1 : (_vm.form.HallgSzervTev)
    },
    on: {
      "click": function($event) {
        _vm.fileBoxChange('hallgSzervTev', 'Hallgatói szervezetben végzett tevékenység az elmúlt egy évben', '', $event, 'hallgSzervTev')
      },
      "__c": function($event) {
        var $$a = _vm.form.HallgSzervTev,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.HallgSzervTev = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.HallgSzervTev = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.HallgSzervTev = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "HallgSzervTev"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Hallgatói szervezetben végzett tevékenység az elmúlt egy évben\n                "), _c('Tooltip', {
    attrs: {
      "description": _vm.getTooltipDescriptionByKey('hallgSzervTev')
    }
  })], 1)])]), _vm._v(" "), _c('textareabox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.HallgSzervTev),
      expression: "form.HallgSzervTev"
    }],
    attrs: {
      "errors": _vm.errors,
      "cstyle": "min-height: 100px",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "HallgSzervTevSzoveg",
      "label": "",
      "name": "HallgSzervTevSzoveg"
    },
    model: {
      value: (_vm.form.HallgSzervTevSzoveg),
      callback: function($$v) {
        _vm.form.HallgSzervTevSzoveg = $$v
      },
      expression: "form.HallgSzervTevSzoveg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.EgyebTev),
      expression: "form.EgyebTev"
    }],
    attrs: {
      "id": "EgyebTev",
      "name": "EgyebTev",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.EgyebTev) ? _vm._i(_vm.form.EgyebTev, "1") > -1 : (_vm.form.EgyebTev)
    },
    on: {
      "click": function($event) {
        _vm.fileBoxChange('EgyebTev', 'Egyéb tevékenység', '', $event, 'EgyebTev')
      },
      "__c": function($event) {
        var $$a = _vm.form.EgyebTev,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.EgyebTev = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.EgyebTev = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.EgyebTev = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "EgyebTev"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Egyéb\n                "), _c('Tooltip', {
    attrs: {
      "description": _vm.getTooltipDescriptionByKey('EgyebTev')
    }
  })], 1)])]), _vm._v(" "), _c('textareabox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.EgyebTev),
      expression: "form.EgyebTev"
    }],
    attrs: {
      "errors": _vm.errors,
      "cstyle": "min-height: 100px",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "EgyebTevSzoveg",
      "label": "",
      "name": "EgyebTevSzoveg"
    },
    model: {
      value: (_vm.form.EgyebTevSzoveg),
      callback: function($$v) {
        _vm.form.EgyebTevSzoveg = $$v
      },
      expression: "form.EgyebTevSzoveg"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.csaladi_allapot_fogyatekossag), function(option, i) {
    return (i >= 0 && i <= 5) ? _c('div', {
      staticClass: "form-checkbox-wrapper",
      class: {
        disabled: option.disabled > 0
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.csaladi_allapot_fogyatekossag),
        expression: "form.csaladi_allapot_fogyatekossag"
      }],
      ref: "'csaladi_allapot_fogyatekossag_'+option.value",
      refInFor: true,
      attrs: {
        "disabled": option.disabled > 0,
        "id": 'csaladi_allapot_fogyatekossag_' + option.value,
        "name": 'csaladi_allapot_fogyatekossag_' + option.value,
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.form.csaladi_allapot_fogyatekossag) ? _vm._i(_vm.form.csaladi_allapot_fogyatekossag, option.value) > -1 : (_vm.form.csaladi_allapot_fogyatekossag)
      },
      on: {
        "change": function($event) {
          _vm.csaladiAllapotFogyatekossagChange('csaladi_allapot_fogyatekossag_' + option.value, option.text, '', '', option.point, $event, option.value)
        },
        "__c": function($event) {
          var $$a = _vm.form.csaladi_allapot_fogyatekossag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.form.csaladi_allapot_fogyatekossag = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.csaladi_allapot_fogyatekossag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.form.csaladi_allapot_fogyatekossag = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'csaladi_allapot_fogyatekossag_' + option.value
      }
    }, [_c('div', {
      staticClass: "icon"
    }), _vm._v("\n                  " + _vm._s(option.text) + "\n                  "), _c('Tooltip', {
      attrs: {
        "description": _vm.getTooltipDescriptionByKey(option.value)
      }
    })], 1)]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.csaladi_allapot_fogyatekossag), function(option, i) {
    return (i >= 6) ? _c('div', {
      staticClass: "form-checkbox-wrapper",
      class: {
        disabled: option.disabled > 0
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.csaladi_allapot_fogyatekossag),
        expression: "form.csaladi_allapot_fogyatekossag"
      }],
      ref: "'csaladi_allapot_fogyatekossag_'+option.value",
      refInFor: true,
      attrs: {
        "disabled": option.disabled > 0,
        "id": 'csaladi_allapot_fogyatekossag_' + option.value,
        "name": 'csaladi_allapot_fogyatekossag_' + option.value,
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.form.csaladi_allapot_fogyatekossag) ? _vm._i(_vm.form.csaladi_allapot_fogyatekossag, option.value) > -1 : (_vm.form.csaladi_allapot_fogyatekossag)
      },
      on: {
        "change": function($event) {
          _vm.csaladiAllapotFogyatekossagChange('csaladi_allapot_fogyatekossag_' + option.value, option.text, '', '', option.point, $event, option.value)
        },
        "__c": function($event) {
          var $$a = _vm.form.csaladi_allapot_fogyatekossag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.form.csaladi_allapot_fogyatekossag = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.csaladi_allapot_fogyatekossag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.form.csaladi_allapot_fogyatekossag = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'csaladi_allapot_fogyatekossag_' + option.value
      }
    }, [_c('div', {
      staticClass: "icon"
    }), _vm._v("\n                  " + _vm._s(option.text) + "\n                  "), _c('Tooltip', {
      attrs: {
        "description": _vm.getTooltipDescriptionByKey(option.value)
      }
    })], 1)]) : _vm._e()
  }))])]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return [(error.id == 'csaladi_allapot_fogyatekossag') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()]
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("\n          A pályázó és/vagy vele egy háztartásban élő személy, aki fogyatékkal él, tartós betegségben szenved vagy orvosi kezelés alatt áll.\n        ")]), _vm._v(" "), (_vm.form.betegsegek.length > 0) ? _c('table', {
    staticClass: "list-table"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.form.betegsegek), function(betegseg, i) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_vm._v(_vm._s(betegseg.BNOKod))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_vm._v(_vm._s(betegseg.BetegsegNeve))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "form-checkbox-wrapper"
    }, [_c('label', {
      attrs: {
        "for": 'PalyazoBetegsege_' + i
      }
    }, [_vm._v("\n                  " + _vm._s(betegseg.PalyazoBetegsege ? 'Igen' : 'Nem') + "\n                ")])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('inputbox', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!betegseg.PalyazoBetegsege),
        expression: "!betegseg.PalyazoBetegsege"
      }],
      attrs: {
        "errors": _vm.errors,
        "iconclass": "fa fa-pencil",
        "regexp_filter": "[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+",
        "id": 'BetegsegCsaladtagNeve_' + i,
        "label": "",
        "name": 'BetegsegCsaladtagNeve_' + i
      },
      model: {
        value: (betegseg.CsaladtagNeve),
        callback: function($$v) {
          betegseg.CsaladtagNeve = $$v
        },
        expression: "betegseg.CsaladtagNeve"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('inputbox', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!betegseg.PalyazoBetegsege),
        expression: "!betegseg.PalyazoBetegsege"
      }],
      attrs: {
        "errors": _vm.errors,
        "iconclass": "fa fa-pencil",
        "regexp_filter": "[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+",
        "id": 'BetegsegCsaladtagRokonsagiFoka_' + i,
        "label": "",
        "name": 'BetegsegCsaladtagRokonsagiFoka_' + i
      },
      model: {
        value: (betegseg.CsaladtagRokonsagiFoka),
        callback: function($$v) {
          betegseg.CsaladtagRokonsagiFoka = $$v
        },
        expression: "betegseg.CsaladtagRokonsagiFoka"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('button', {
      staticClass: "button only-icon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.betegsegTorles(betegseg.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('select2ajax', {
    attrs: {
      "url": "/hatar/betegseg_kereses",
      "id": "uj_betegseg_BNOKod",
      "label": "Betegség kódja / megnevezése",
      "name": "uj_betegseg_BNOKod"
    },
    model: {
      value: (_vm.betegsegek),
      callback: function($$v) {
        _vm.betegsegek = $$v
      },
      expression: "betegsegek"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n            Pályázó betegsége\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_betegseg.PalyazoBetegsege),
      expression: "uj_betegseg.PalyazoBetegsege"
    }],
    attrs: {
      "id": "uj_betegseg_PalyazoBetegsege",
      "name": "uj_betegseg_PalyazoBetegsege",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.uj_betegseg.PalyazoBetegsege) ? _vm._i(_vm.uj_betegseg.PalyazoBetegsege, "1") > -1 : (_vm.uj_betegseg.PalyazoBetegsege)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.uj_betegseg.PalyazoBetegsege,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.uj_betegseg.PalyazoBetegsege = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.uj_betegseg.PalyazoBetegsege = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.uj_betegseg.PalyazoBetegsege = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('inputbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.uj_betegseg.PalyazoBetegsege),
      expression: "!uj_betegseg.PalyazoBetegsege"
    }],
    attrs: {
      "iconclass": "fa fa-pencil",
      "regexp_filter": "[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+",
      "id": "uj_betegseg_CsaladtagNeve",
      "label": "Családtag neve",
      "name": "uj_betegseg_CsaladtagNeve"
    },
    model: {
      value: (_vm.uj_betegseg.CsaladtagNeve),
      callback: function($$v) {
        _vm.uj_betegseg.CsaladtagNeve = $$v
      },
      expression: "uj_betegseg.CsaladtagNeve"
    }
  }), _vm._v(" "), _c('inputbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.uj_betegseg.PalyazoBetegsege),
      expression: "!uj_betegseg.PalyazoBetegsege"
    }],
    attrs: {
      "iconclass": "fa fa-pencil",
      "regexp_filter": "[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+",
      "id": "uj_betegseg_CsaladtagRokonsagiFoka",
      "label": "Családtag rokonsági foka",
      "name": "uj_betegseg_CsaladtagRokonsagiFoka"
    },
    model: {
      value: (_vm.uj_betegseg.CsaladtagRokonsagiFoka),
      callback: function($$v) {
        _vm.uj_betegseg.CsaladtagRokonsagiFoka = $$v
      },
      expression: "uj_betegseg.CsaladtagRokonsagiFoka"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "button v3",
    attrs: {
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": _vm.betegsegHozzaad
    }
  }, [_vm._v("Új betegség hozzáadása")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "iconclass": "fa fa-pencil",
      "regexp_filter": "[0-9]{1,2}[.]{0,1}[0-9]{0,2}",
      "id": "BalDioptria",
      "label": "Bal dioptria",
      "name": "BalDioptria"
    },
    on: {
      "onchange": _vm.szembetegsegPontKalk
    },
    model: {
      value: (_vm.form.BalDioptria),
      callback: function($$v) {
        _vm.form.BalDioptria = $$v
      },
      expression: "form.BalDioptria"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "iconclass": "fa fa-pencil",
      "regexp_filter": "[0-9]{1,2}[.]{0,1}[0-9]{0,2}",
      "id": "JobbDioptria",
      "label": "Jobb dioptria",
      "name": "JobbDioptria"
    },
    on: {
      "onchange": _vm.szembetegsegPontKalk
    },
    model: {
      value: (_vm.form.JobbDioptria),
      callback: function($$v) {
        _vm.form.JobbDioptria = $$v
      },
      expression: "form.JobbDioptria"
    }
  })], 1)]), _vm._v(" "), _c('textareabox', {
    attrs: {
      "errors": _vm.errors,
      "cstyle": "min-height: 100px",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "Palyazo_Betegsege",
      "label": "Megjegyzés",
      "name": "Palyazo_Betegsege"
    },
    model: {
      value: (_vm.form.Palyazo_Betegsege),
      callback: function($$v) {
        _vm.form.Palyazo_Betegsege = $$v
      },
      expression: "form.Palyazo_Betegsege"
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("\n          A pályázóval közös háztartásban élők előző havi nettó jövedelme (forintban).\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "list-table"
  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.form.jovedelmek), function(jovedelem, i) {
    return (_vm.form.jovedelmek.length > 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "form-checkbox-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jovedelem.Palyazo),
        expression: "jovedelem.Palyazo"
      }],
      attrs: {
        "id": 'jovedelem_palyazo_' + i,
        "name": 'jovedelem_palyazo_' + i,
        "type": "checkbox",
        "value": "1"
      },
      domProps: {
        "checked": Array.isArray(jovedelem.Palyazo) ? _vm._i(jovedelem.Palyazo, "1") > -1 : (jovedelem.Palyazo)
      },
      on: {
        "change": function($event) {
          _vm.jovedelemPalyazoChange(i)
        },
        "__c": function($event) {
          var $$a = jovedelem.Palyazo,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "1",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (jovedelem.Palyazo = $$a.concat($$v))
            } else {
              $$i > -1 && (jovedelem.Palyazo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            jovedelem.Palyazo = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'jovedelem_palyazo_' + i
      }
    }, [_c('div', {
      staticClass: "icon"
    })])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('inputbox', {
      attrs: {
        "errors": _vm.errors,
        "iconclass": "fa fa-pencil",
        "id": 'jovedelem_nev_' + i,
        "label": "",
        "name": 'jovedelem_nev_' + i
      },
      on: {
        "onkeyup": function($event) {
          _vm.jovedelemUploaderBlokkModositas(jovedelem.id)
        }
      },
      model: {
        value: (jovedelem.Nev),
        callback: function($$v) {
          jovedelem.Nev = $$v
        },
        expression: "jovedelem.Nev"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('inputbox', {
      attrs: {
        "errors": _vm.errors,
        "iconclass": "fa fa-pencil",
        "id": 'jovedelem_rokonsagi_fok_' + i,
        "label": "",
        "name": 'jovedelem_rokonsagi_fok_' + i
      },
      model: {
        value: (jovedelem.Rokonsagi_Fok),
        callback: function($$v) {
          jovedelem.Rokonsagi_Fok = $$v
        },
        expression: "jovedelem.Rokonsagi_Fok"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jovedelem.Tipus),
        expression: "jovedelem.Tipus"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'jovedelem_tipus_' + i,
        "id": 'jovedelem_tipus_' + i
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          jovedelem.Tipus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function () {
          _vm.jovedelemUploaderBlokkModositas(jovedelem.id);
          _vm.kalkJovedelemTipusok();
          _vm.jovedelmekPontKalkulacio();
        }]
      }
    }, _vm._l((_vm.jovedelem_tipusok), function(jt, i) {
      return _c('option', {
        domProps: {
          "value": jt.value
        }
      }, [_vm._v(_vm._s(jt.text))])
    }))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('inputbox', {
      attrs: {
        "errors": _vm.errors,
        "regexp_filter": "[0-9]+",
        "iconText": "Ft",
        "id": 'jovedelem_osszeg_' + i,
        "label": "",
        "name": 'jovedelem_osszeg_' + i
      },
      on: {
        "onkeyup": function () {
          _vm.jovedelmekPontKalkulacio();
          _vm.kalkJovedelemOsszeg();
        }
      },
      model: {
        value: (jovedelem.Osszeg),
        callback: function($$v) {
          jovedelem.Osszeg = $$v
        },
        expression: "jovedelem.Osszeg"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('button', {
      staticClass: "button only-icon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.jovdelemTorles(jovedelem.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper",
    on: {
      "change": _vm.ujJovedelemPalyazoChange
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_jovedelem.Palyazo),
      expression: "uj_jovedelem.Palyazo"
    }],
    attrs: {
      "id": "uj_jovedelem_palyazo",
      "name": "uj_jovedelem_palyazo",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.uj_jovedelem.Palyazo) ? _vm._i(_vm.uj_jovedelem.Palyazo, "1") > -1 : (_vm.uj_jovedelem.Palyazo)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.uj_jovedelem.Palyazo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.uj_jovedelem.Palyazo = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.uj_jovedelem.Palyazo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.uj_jovedelem.Palyazo = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+",
      "iconclass": "fa fa-pencil",
      "id": "uj_jovedelem_nev",
      "label": "",
      "name": "uj_jovedelem_nev"
    },
    model: {
      value: (_vm.uj_jovedelem.Nev),
      callback: function($$v) {
        _vm.uj_jovedelem.Nev = $$v
      },
      expression: "uj_jovedelem.Nev"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[a-zA-z öüóőúéáűíÖÜÓŐÚÉÁŰÍ.]+",
      "iconclass": "fa fa-pencil",
      "id": "uj_jovedelem_rokonsagi_fok",
      "label": "",
      "name": "uj_jovedelem_rokonsagi_fok"
    },
    model: {
      value: (_vm.uj_jovedelem.Rokonsagi_Fok),
      callback: function($$v) {
        _vm.uj_jovedelem.Rokonsagi_Fok = $$v
      },
      expression: "uj_jovedelem.Rokonsagi_Fok"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_jovedelem.Tipus),
      expression: "uj_jovedelem.Tipus"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uj_jovedelem_tipus",
      "id": "uj_jovedelem_tipus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.uj_jovedelem.Tipus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jovedelem_tipusok), function(jt, i) {
    return _c('option', {
      domProps: {
        "value": jt.value
      }
    }, [_vm._v(_vm._s(jt.text))])
  }))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "iconText": "Ft",
      "id": "uj_jovedelem_osszeg",
      "label": "",
      "name": "uj_jovedelem_osszeg"
    },
    model: {
      value: (_vm.uj_jovedelem.Osszeg),
      callback: function($$v) {
        _vm.uj_jovedelem.Osszeg = $$v
      },
      expression: "uj_jovedelem.Osszeg"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('button', {
    staticClass: "button v3 only-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.jovedelemHozzaad
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "points"
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, _vm._l((_vm.jovedelem_tipusok_kalk), function(jt) {
    return _c('div', {
      staticClass: "point-block"
    }, [_c('div', {
      staticClass: "point"
    }, [_vm._v("\n                  " + _vm._s(jt.pont) + "\n                ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(jt.db) + " x")]), _vm._v(" " + _vm._s(jt.cim) + "\n              ")])
  })), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [(_vm.jovedelem_osszeg_kalk != 0) ? _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "point"
  }, [_vm._v("\n                  " + _vm._s(_vm.jovedelem_osszeg_pont) + "\n                ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.jovedelem_osszeg_kalk) + " Ft")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [(_vm.jovedelem_osszpont != 0) ? _c('div', {
    staticClass: "point-block"
  }, [_c('div', {
    staticClass: "point dark"
  }, [_vm._v("\n                  " + _vm._s(_vm.jovedelem_osszpont) + "\n                ")])]) : _vm._e()])])], 2), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nyilatkozat),
      expression: "form.nyilatkozat"
    }],
    attrs: {
      "id": "nyilatkozat",
      "name": "nyilatkozat",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.nyilatkozat) ? _vm._i(_vm.form.nyilatkozat, "1") > -1 : (_vm.form.nyilatkozat)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.nyilatkozat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.nyilatkozat = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.nyilatkozat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.nyilatkozat = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return [(error.id == 'nyilatkozat') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld",
      "disabled": !_vm.save_enabled
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "veglegesit",
      "disabled": !_vm.save_enabled
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")])])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fill_info != ''),
      expression: "fill_info != ''"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Rendszeres szociális támogatás és költségtérítés mérséklés")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }), _vm._v(" "), (_vm.urlap_letoltheto) ? _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rendszeresSzocialisTamogatasPdf
    }
  }, [_vm._v("Pályázat letöltése")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Szülői adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Igényelt támogatások")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Költségtérítés mérséklés")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Családi állapot és fogyatékosság")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Betegség")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Kód")]), _vm._v(" "), _c('th', [_vm._v("Megnevezés")]), _vm._v(" "), _c('th', [_vm._v("Pályázó betegsége")]), _vm._v(" "), _c('th', [_vm._v("Családtag neve")]), _vm._v(" "), _c('th', [_vm._v("Rokonsági fok")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "uj_betegseg_PalyazoBetegsege"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n              Igen\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Pályázó szembetegsége")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box warning"
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Figyelem!")]), _vm._v(" A dioptria értékeket csak akkor vesszük figyelembe, ha a \"Betegségek\" blokkban felvette saját betegségként szembetegségét.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("\n            Nettó jövedelem\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Pályázó")]), _vm._v(" "), _c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Rokonsági fok")]), _vm._v(" "), _c('th', [_vm._v("Típus")]), _vm._v(" "), _c('th', [_vm._v("Jövedelem")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "51px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "uj_jovedelem_palyazo"
    }
  }, [_c('div', {
    staticClass: "icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          A pályázat igazolások nélkül "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("érvénytelennek")]), _vm._v(" minősül.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Hallgatói nyilatkozat")]), _vm._v(" "), _c('div', {
    staticClass: "form-scroll-block"
  }, [_vm._v("A jelentkezési lapon szereplő személyes adatok kezelése az érintett önkéntes hozzájárulásán alapul, mely hozzájárulást az érintett a pályázati adatlap kitöltésével és annak aláírásával ad meg."), _c('br'), _c('br'), _vm._v("Az adatkezelők harmadik személy(ek) részére adattovábbítást nem végeznek."), _c('br'), _c('br'), _vm._v("Az érintett hozzájárulása indokolás nélkül bármikor visszavonható."), _c('br'), _c('br'), _vm._v("A kezelt adatokba betekintést kizárólag az adatkezelők ösztöndíj elnyerésére való jogosultság megállapításával, annak elbírálásával, valamint az ösztöndíj folyósításával összefüggő feladatokat ellátó munkatársa(i) nyerhet(nek) a fenti feladatok ellátásához szükséges ideig és mértékben. A jelentkezési lapon szereplő adatok a jelentkezés sikertelensége esetén az elbírálást követő 1 hónapig kezelhetőek."), _c('br'), _c('br'), _vm._v("Pozitív elbírálás esetén a Széchenyi István Egyetem az EFOP-3.6.1-16-2016-00017 pályázat keretében az ösztöndíjas hallgatóról megismert személyes adatokat az ösztöndíjszerződés lejáratát követő 8 évig jogosult kezelni."), _c('br'), _c('br'), _vm._v("Az érintett az adatkezelés teljes időtartama alatt élhet az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvényben biztosított jogával, (tájékoztatáshoz, helyesbítéshez, törléshez, zároláshoz, tiltakozáshoz való jog) továbbá jogsérelem esetén bírósághoz, valamint a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (1125 Budapest, Szilágyi Erzsébet fasor 22/c., tel.: 06-1-391-1400, honlap URL címe: http://naih.hu, elektronikus levelezési cím: ugyfelszolgalat@naih.hu ) is fordulhat.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozat"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n              Büntetőjogi felelősségem tudatában tudomásul veszem a fentieket\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cdce1d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/rendszeres_szocialis_tamogatas.vue
// module id = 385
// module chunks = 0